import { UserGroupDataQualityField, type UserGroupDataQualityRecord } from '@navio/nsdk';
import { isSharedPhoneNumberIssue } from './userGroupDataQualityTexts';

/** A backoffice surface that can change the field. Lease-contact issues have none. */
export type StaffDataQualityFix = 'addresses' | 'contact' | 'organization';

/** Fix -> the report fields it can clear, in the order a page should offer them. */
const FIX_FIELDS: ReadonlyArray<readonly [StaffDataQualityFix, ReadonlySet<UserGroupDataQualityField>]> = [
  ['addresses', new Set([UserGroupDataQualityField.INVOICE_ADDRESS])],
  [
    'contact',
    new Set([
      UserGroupDataQualityField.PRIMARY_CONTACT,
      UserGroupDataQualityField.NAME,
      UserGroupDataQualityField.MOBILE_PHONE_NUMBER,
      UserGroupDataQualityField.EMAIL
    ])
  ],
  ['organization', new Set([UserGroupDataQualityField.ORGANIZATION_NUMBER])]
];

/**
 * Staff surfaces that can fix this report, in the order a page should offer them.
 * Empty when every issue is only something to report. Callers pick the first fix
 * they have an editor for — see the `Partial<Record<StaffDataQualityFix, ...>>`
 * route maps in the admin and partner pages.
 */
export const getStaffDataQualityFixes = (record: UserGroupDataQualityRecord): StaffDataQualityFix[] =>
  FIX_FIELDS.filter(([, fields]) =>
    record.issues.some((issue) => fields.has(issue.field) && !isSharedPhoneNumberIssue(issue))
  ).map(([fix]) => fix);
